import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Navbar } from "@/components/Navbar";
import { useLang } from "@/lib/i18n";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError(t("passwords_mismatch"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("reset_success"));
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background blueprint-grid">
      <Navbar />
      <div className="max-w-md mx-auto px-4 pt-16 sm:pt-24 pb-16">
        <div className="border border-border rounded-xl bg-card p-8 fade-up">
          <h1 className="font-heading font-extrabold text-2xl tracking-tight">{t("forgot_password_title")}</h1>
          {!token ? (
            <div className="mt-8" data-testid="reset-password-invalid">
              <p className="text-sm text-destructive">{t("reset_link_invalid")}</p>
              <Link to="/forgot-password" data-testid="goto-forgot-link" className="text-sm text-accent hover:underline block mt-4">{t("forgot_password_title")}</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div className="space-y-2">
                <Label htmlFor="password">{t("new_password")}</Label>
                <Input id="password" type="password" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="confirm">{t("confirm_password")}</Label>
                <Input id="confirm" type="password" data-testid="reset-password-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
              </div>
              {error && <p data-testid="reset-password-error" className="text-sm text-destructive">{error}</p>}
              <Button type="submit" data-testid="reset-password-submit-btn" disabled={loading} className="w-full rounded-full active:scale-95">
                {loading ? "..." : t("reset_password_btn")}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
